import Icon from '@material-ui/icons/AirlineSeatReclineExtra';
import BleedLogsList from './BleedLogsList'

export default {
    list: BleedLogsList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
